import React, { useState, Dispatch, SetStateAction } from "react";
import styled from "styled-components";
import { LineBoxContainer } from "../../../../../pages/UserLog/UserLog";
import CalendarLineBtn from "../../../../Button/CalendarLineBtn";
import DropDown, { OptionType } from "../../../../Filters/DropDown";
import CalendarModal from "../../../../Modal/CalendarModal";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";

interface MaintenanceTimeModalProps extends DefaultModalCommonProps {
  endDate: string;
  setEndDate: Dispatch<SetStateAction<string>>;
  hourDropdownValue: OptionType;
  setHourDropdownValue: Dispatch<SetStateAction<OptionType>>;
  minuteDropdownValue: OptionType;
  setMinuteDropdownValue: Dispatch<SetStateAction<OptionType>>;
}

export default function MaintenanceTimeModal({
  closeEvent,
  confirmEvent,
  endDate,
  setEndDate,
  hourDropdownValue,
  setHourDropdownValue,
  minuteDropdownValue,
  setMinuteDropdownValue,
}: MaintenanceTimeModalProps) {
  const [endDateClick, setEndDateClick] = useState(false);

  // 시간 선택 옵션
  const hourOptionList = [];
  const hourList = Array.from({ length: 24 }, (_, i) => i);

  for (let i = 0; i < hourList.length; i++) {
    const e = hourList[i];
    hourOptionList.push({
      value: e < 10 ? `0${e}` : `${e}`,
      label: e < 10 ? `0${e}` : `${e}`,
    });
  }

  // 분 선택 옵션
  const minuteOptionList = [];
  const minuteList = Array.from({ length: 6 }, (_, i) => i);

  for (let i = 0; i < minuteList.length; i++) {
    const e = minuteList[i];
    minuteOptionList.push({ value: `${e}0`, label: `${e}0` });
  }

  return (
    <DefaultModalLayout
      modalTitle="서버 점검 종료 시간 설정"
      isSmallModal={true}
      closeEvent={() => closeEvent()}
      confirmEvent={() => {
        if (confirmEvent) confirmEvent();
      }}
      type="input"
      confirmDisabled={
        endDate === "선택" ||
        hourDropdownValue?.value === "" ||
        minuteDropdownValue?.value === ""
      }
    >
      {/* 종료 날짜 */}
      <Row>
        <ModalLabel>종료 날짜</ModalLabel>

        <ValueContainer>
          <LineBoxContainer>
            <CalendarLineBtn
              onClickEvent={() => setEndDateClick(true)}
              value={endDate}
              initValue={"선택"}
            />

            {endDateClick && (
              <CalendarModal
                closeEvent={() => setEndDateClick(false)}
                changeEvent={(date: string) => setEndDate(date)}
              />
            )}
          </LineBoxContainer>
        </ValueContainer>
      </Row>

      {/* 종료 일시 */}
      <Row>
        <ModalLabel>종료 일시</ModalLabel>

        <ValueContainer>
          <DropDown
            setDropDownValue={setHourDropdownValue}
            dropdownValue={hourDropdownValue}
            optionList={hourOptionList}
            boxWidth={160}
          />

          <DropDown
            setDropDownValue={setMinuteDropdownValue}
            dropdownValue={minuteDropdownValue}
            optionList={minuteOptionList}
            boxWidth={160}
          />
        </ValueContainer>
      </Row>
    </DefaultModalLayout>
  );
}

const Row = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;

const ValueContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
`;
